module.exports = __webpack_public_path__ + "img/Inflammation-OVCA_10X_OC.66a4b8ab.png";